import { compose, space as styledSpace } from 'styled-system';
import margin from './margin';
import padding from './padding';

const space = compose(styledSpace, margin, padding);
// eslint-disable-next-line security/detect-object-injection
space.css = (type, value) => props => space[type]({ theme: props.theme, [type]: value });
export default space;
